import React from "react";
import { useAppSelector } from "store/hooks";
import { selectAllLocations } from "store/reducers/location/locationSlice";

import { SelectDropDown } from "../components/selectDropDown";

type Props = {
  showDeleted?: boolean;
  emptyOptionLabel?: string | null;
} & React.ComponentProps<typeof SelectDropDown>;

export const LocationDropdown = (props: Props) => {
  const { showDeleted = true, emptyOptionLabel = "Unspecified", ...rest } = props;
  let mriLocations = useAppSelector(selectAllLocations);
  if (!mriLocations.length) return null;

  if (!showDeleted) {
    mriLocations = mriLocations.filter((location) => !location.deleted);
  }

  return (
    <SelectDropDown {...rest}>
      {mriLocations.map((site) => (
        <option key={site.id} value={site.id}>
          {site.name}
        </option>
      ))}
      {emptyOptionLabel !== null && <option value="">{emptyOptionLabel}</option>}
    </SelectDropDown>
  );
};
